var React = require('react');
var Title = require('fdna-common-components/dist/components/Title/Title');
var InputText = require('fdna-common-components/dist/components/Forms/InputText');
var Button = require('fdna-common-components/dist/components/Forms/Button');
var Checkbox = require('fdna-common-components/dist/components/Forms/Checkbox');
var RadioButton = require('fdna-common-components/dist/components/Forms/RadioButton');
var KeyboardUserEvent = require('fdna-common-components/dist/mixins/KeyboardUserEvent');

import Select from 'react-select';

var OTHER_REGISTER_OPTIONS = require('../../../constants').OTHER_REGISTER_OPTIONS;
import { trackEvent } from 'fdna-common-components/dist/libs/utils';
import { AUTH_LIBRARY_APP } from '../../../config/auth';
import { checkEmail } from '../../classes/signUpFormValidations';
import { staticUrl } from '../../../common/staticUrl';

var RegisterNewAccount = React.createClass({
    mixins: [KeyboardUserEvent],
    propTypes: {
        first_name: React.PropTypes.string,
        first_name_valid: React.PropTypes.bool,
        last_name: React.PropTypes.string,
        last_name_valid: React.PropTypes.bool,
        email: React.PropTypes.string,
        email_valid: React.PropTypes.bool,
        error_message: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]),
        onFieldsChange: React.PropTypes.func,
        onContinue: React.PropTypes.func,
        app: React.PropTypes.string
    },
    getDefaultProps: function () {
        return {
            first_name: "",
            first_name_valid: true,
            last_name: "",
            last_name_valid: true,
            email: "",
            email_valid: true,
            error_message: "",
            onFieldsChange: function () { },
            onContinue: function () { },
            app: ''
        };
    },

    getInitialState: function () {
        return {
            first_name: this.props.first_name,
            last_name: this.props.last_name,
            email: this.props.email,
            first_name_onblur: false,
            last_name_onblur: false,
            email_name_onblur: false,
            promo: null,
            accept_tos: false,
            accept_tos_error: true
        }
    },

    onFieldsChange: function (field, event) {
        var state = this.state;
        state[field] = event.target.value;

        this.props.onFieldsChange(state);
    },

    onAcceptTos: function (event, field, value) {
        var newState = _.assign({}, this.state, { accept_tos: value });
        this.props.onFieldsChange(newState);
        this.setState(newState);
        this.setState({ accept_tos_error: value })
    },

    focusByName: function (name) {
        if (this.refs[name] && this.refs[name]['focus']) {
            this.refs[name].focus();
        }
    },

    onKeyboardKeyUp: function (e) {
        if (e.keyCode == 13) {
            this._continue();
        }
    },


    _continue: function () {
        if (this.isContinueEnabled()) {

            var purposeSelection = _.assign({}, this.state.otherRegisterType, { healthCare: this.state.toggleHealthCare != 'other' });

            this.props.onContinue(purposeSelection);
        }
    },

    checkName: function (name) {
        var re = /^([#?!@$%^&_*-/{/}/)/(\[\]A-Za-z ])*$/;
        return re.test(name);
    },

    isContinueEnabled: function () {
        return this.state.first_name.trim().length > 1 &&
            this.state.last_name.trim().length > 1 &&
            this.state.email.trim().length > 0 &&
            this.checkName(this.state.first_name) &&
            this.checkName(this.state.last_name) &&
            checkEmail(this.state.email) &&
            (this.state.toggleHealthCare && (this.state.toggleHealthCare != 'other' || this.state.otherRegisterType)) &&
            this.state.accept_tos;

    },

    onSelectRegistrationType: function (selection) {
        this.setState({ toggleHealthCare: 'other', otherRegisterType: selection });
        trackEvent({ category: "Register", action: selection.analytics, label: "" });
    },

    onToggleHealthCare: function (selection) {
        this.setState({ toggleHealthCare: selection });
    },
    render: function () {
        var registerSelect = <div className="select-container"><div className="select-text">No, I am</div><Select options={OTHER_REGISTER_OPTIONS} placeholder="Please Select" value={this.state.otherRegisterType} clearable={false} searchable={false} onChange={this.onSelectRegistrationType} /></div>;
        var healthCareOptions = [{ label: 'Yes, I am a healthcare professional', value: 'healthcare' }, { value: 'other', component: registerSelect }];
        var enableContinue = this.isContinueEnabled();

        var buttonMode = enableContinue ? "action" : "disabled";
        var inputWidth = this.props.app == AUTH_LIBRARY_APP ? 265 : 400;
        var classesToAdd = this.props.app == AUTH_LIBRARY_APP ? " register-new-account-library" : '';
        return (
            <div className={"register-login register-new-account" + classesToAdd}>
                <div className="welcome-container">
                    <div className="Face2Gene-is-designa">
                        Face2Gene<sup className="trade-mark-supscript">TM</sup> is designated to be used solely by healthcare professionals in non-urgent outpatient settings and should not be used by anyone without proper medical training. It is a search & reference tool provided for informational purposes and not intended to replace the clinician’s judgment or experience, nor should it be used to diagnose or treat medical conditions.
                    </div>
                </div>

                <div className="detail-container">
                    <div className="personal-info">
                        <div className="icon-value icon-value-right f-t-auto fields-tbl f-t-middle input-text nw-first-name-input ">
                            <div className="i-v-content">
                                <input type="text" placeholder="First Name *" value={this.props.first_name} onChange={this.onFieldsChange.bind(this, "first_name")} onBlur={() => this.setState({ first_name_onblur: true })} autoComplete="off" maxLength={50} ref="first_name" />
                                {this.state.first_name_onblur ? this.props.first_name_valid ? this.state.first_name.trim().length > 0 ? this.state.first_name.trim().length > 1 ? this.checkName(this.state.first_name) ? <div className="check-copy" /> : <div className="error-text">Numbers are not allowed</div> : <div className="error-text">Minimum 2 characters required</div> : <div className="error-text">Please fill in this field</div>
                                    : <div className="error-text">{this.props.error_message}</div> : null}
                            </div>
                        </div>
                        <div className="icon-value icon-value-right f-t-auto fields-tbl f-t-middle input-text nw-last-name-input ">
                            <div className="i-v-content">
                                <input type="text" placeholder="Last Name *" value={this.props.last_name} onChange={this.onFieldsChange.bind(this, "last_name")} onBlur={() => this.setState({ last_name_onblur: true })} autoComplete="off" maxLength={50} ref="last_name" />
                                {this.state.last_name_onblur ? this.props.last_name_valid ? this.state.last_name.trim().length > 0 ? this.state.last_name.trim().length > 1 ? this.checkName(this.state.last_name) ? <div className="check-copy" /> : <div className="error-text">Numbers are not allowed</div> : <div className="error-text">Minimum 2 characters required</div> : <div className="error-text">Please fill in this field</div>
                                    : <div className="error-text">{this.props.error_message}</div> : null}
                            </div>
                        </div>
                        <div className="icon-value icon-value-right f-t-auto fields-tbl f-t-middle input-text nw-email-input ">
                            <div className="i-v-content">
                                <input type="text" placeholder="Email *" value={this.props.email} onChange={this.onFieldsChange.bind(this, "email")} autoComplete="off" onBlur={() => this.setState({ email_onblur: true })} maxLength={254} ref="email" />
                                {this.state.email_onblur ? this.props.email_valid ? this.state.email.trim().length > 0 ? checkEmail(this.state.email) ? <div className="check-copy" /> : <div className="error-text">Please check your email address</div> : <div className="error-text">Please fill in this field</div>
                                    : <div className="error-text">{this.props.error_message}</div> : null}
                            </div>
                        </div>
                    </div>
                    <div className="professional-info">
                        <div className="Are-you-a-healthcare">
                            Are you a healthcare professional? *
                        </div>
                        <div className="select-option-warning-container">
                            <span className="Please-select-one-of">
                                Please select one of these options
                            </span>
                        </div>
                        <div className="radio-button-container">
                            <RadioButton options={healthCareOptions} onChange={this.onToggleHealthCare} value={this.state.toggleHealthCare || false} checkIcon="icon-radio-selected" uncheckIcon="icon-radio-unselected" />
                            {this.state.toggleHealthCare && this.state.toggleHealthCare == 'other' && !this.state.otherRegisterType && <div className="error-text">Please select option</div>}
                        </div>
                    </div>
                </div>

                <div className="terms-and-policy-container">
                    <div className="terms-and-policy">
                        <Checkbox onChange={this.onAcceptTos} checked={this.state.accept_tos} />
                        <span className="I-consent-to-FDNA-st">
                            I consent to FDNA storing my information and communicating with me according to their <a className="text-style-1" href={staticUrl.face2geneTermsAndConditions} target="_blank">Terms of Use</a> and <a href={staticUrl.face2geneTermsAndConditions} target="_blank" className="text-style-2">Privacy Policy.</a><span className="text-style-3"> *</span>
                        </span>
                    </div>
                    {!this.state.accept_tos_error && <div className="error-text">Please accept the Terms and Conditions and Privacy Policy to continue</div>}
                </div>


                <div className="button-container">
                    <Button mode={buttonMode} label="CONTINUE" className="nw-continue-register" onClick={this._continue} ></Button>
                </div>

                <div className="sign-in-container">
                    Already have an account?{" "} <a href={'/auth/sign-in?app=' + this.props.app} className="sign-in-text"> Log in</a>
                </div>

            </div>
        )
    }
});


module.exports = RegisterNewAccount;



// WEBPACK FOOTER //
// ./auth/components/RegisterNewAccount/RegisterNewAccount.jsx